import { ChecklistSubCategoryInterface } from '../interfaces/checklistSubCategory';
import { ChecklistCategory } from "./checklistCategory";

export class ChecklistSubCategory implements ChecklistSubCategoryInterface {
    id_checklist_subcategory?: number;
    fk_id_checklist_category?: number;
    checklist_category: ChecklistCategory;
    code: string;
    name: string;
    level: string;
    standard: string;
    documents: string;

    constructor() {
        this.fk_id_checklist_category = 0;
        this.checklist_category = new ChecklistCategory();
        this.code = '';
        this.name = '';
        this.level = '';
        this.standard = '';
        this.documents = '';
    }
}